/**
 * Invoice status constants - Simplified for V2 flexible workflow
 * These are used across the frontend application to maintain consistency with backend status values
 * Each entity (invoice, aufmass, supplier info) manages its own status independently
 */

export const INVOICE_STATUS = {
	DRAFT: "INVOICE_DRAFT",
	FINALIZED: "INVOICE_FINALIZED",
	REJECTED: "INVOICE_REJECTED",
	ARCHIVED: "INVOICE_ARCHIVED",
};

// Helper function to check if the invoice is in a specific status
export const isInvoiceStatus = (invoice, status) => {
	return invoice?.status === status;
};

// Helper function to get status display text translation key
export const getStatusTranslationKey = (status) => {
	return `invoice.status.${status}`;
};

export default INVOICE_STATUS;
